import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyAboutSectionComponent } from '../../../sections/property-default-sections/property-about-section/property-about-section.component';
import { PropertyPageBase } from '../../property-page-base';
import { PropertyListingTitleSectionComponent } from '../../../sections/residential-for-sale/property-listing-title-section/property-listing-title-section.component';
import { PropertyAgencyReferenceSectionComponent } from '../../../sections/residential-for-sale-agent/property-agency-reference-section/property-agency-reference-section.component';
import { PropertySaleAttributeSectionComponent } from '../../../sections/lifestyle/property-sale-attribute-section/property-sale-attribute-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';

@Component({
    templateUrl: './property-description-page.component.html',
    styleUrls: ['./property-description-page.component.scss']
})
export class ResidentialForSaleAgentPropertyDescriptionComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    sideCardIcon = '/sell/property/assets/property-ui/phone.svg';
    sideCardHeading =
        'How can I get the best price for my property?';
    sideCardCallToActionText = 'Agent Marketing Centre';
    sideCardCallToActionLink =
        'https://www.trademe.co.nz/c/property-industry/insights-and-tips';
    @ViewChild(PropertyListingTitleSectionComponent, {
        read: PropertyListingTitleSectionComponent
    })
    propertyListingTitleSectionComponent: PropertyListingTitleSectionComponent;

    @ViewChild(PropertyAboutSectionComponent, {
        read: PropertyAboutSectionComponent
    })
    propertyAboutSectionComponent: PropertyAboutSectionComponent;

    @ViewChild(PropertySaleAttributeSectionComponent, {
        read: PropertySaleAttributeSectionComponent
    })
    propertySaleAttributeSectionComponent: PropertySaleAttributeSectionComponent;

    @ViewChild(PropertyAgencyReferenceSectionComponent, {
        read: PropertyAgencyReferenceSectionComponent
    })
    propertyAgencyReferenceSectionComponent: PropertyAgencyReferenceSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyDescription, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyListingTitleSectionComponent);
        super.registerSection(this.propertyAboutSectionComponent);
        super.registerSection(this.propertySaleAttributeSectionComponent);
        super.registerSection(this.propertyAgencyReferenceSectionComponent);
    }
}
